import React from 'react'
import { Button } from 'semantic-ui-react'
import ButtonAction from './Button'

function ListButton({ message }) {
  const attachment = message.attachments[0];
  console.log(message);
  return (
    <div>
      <Button style={{background: 'none', padding: '0'}}>
        {
          attachment.content.buttons.map((button, index) => (
            <ButtonAction
              button={button}
              key={`${message.id}-buttons-${index}`}
            />
          ),
          )
        }
      </Button>
    </div>
  )
}

export default ListButton



// WEBPACK FOOTER //
// ./src/views/components/ListButton.js